module.exports = __webpack_public_path__ + "static/img/doc_item.ed4a69a1.png";